import { useCallback, useEffect, useMemo } from "react";
import { useTheme } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import { Theme } from "@material-ui/core";
import { useAtomicStyles } from "styles";
import { useDispatch, useSelector } from "react-redux";
import { useCurrentMerchantId } from "hooks";
import { actions, selectors } from "redux-store";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    inline: {
      display: "inline",
      padding: "1%",
    },
    gridItem: {
      padding: "1%",
    },
    gridContainer: {},
    paperDetail: {},
    posterContainer: {
      display: "flex",
      flexDirection: "row-reverse",
      marginTop: "2em",
      width: "100%",
    },
    posterResizer: {
      width: 200,
      height: 300,
    },
    poster: {
      width: "100%",
      maxWidth: 600,
      margin: "0 auto",
      display: "block",
    },
  }),
);

const useProfileSection = () => {
  const theme = useTheme();
  const styles = useStyles(theme);
  const classes = useMemo(() => ({}), []);
  const atomicStyles = useAtomicStyles();
  const dispatch = useDispatch();
  const merchantId = useCurrentMerchantId();
  const posterUri = useSelector(selectors.getMerchantsList).find(
    (m) => m._id === merchantId,
  ).posterUri;
  const isRegeneratingPoster = useSelector(
    selectors.getAjaxIsLoadingByApi(
      actions.postMerchantsPostersByMerchantId.api,
    ),
  );

  const handleRegeneratePoster = useCallback(() => {
    dispatch(
      actions.postMerchantsPostersByMerchantId.request({
        merchantId,
      }),
    );
  }, [dispatch, merchantId]);

  return {
    styles,
    classes,
    atomicStyles,
    posterUri,
    handleRegeneratePoster,
    isRegeneratingPoster,
  };
};

export { useProfileSection as default };
